import * as React from "react"
import { Link, graphql } from "gatsby"
//import { GatsbyImage } from "gatsby-plugin-image";
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Disqus } from 'gatsby-plugin-disqus';

import Bio from "../components/bio"
import Layout from "../components/layout"
import Seo from "../components/seo"
import PostCard from "../components/postCard"
import YouTubeIcon from '@mui/icons-material/YouTube';

import { ThemeProvider } from '@mui/material/styles';
import { theme } from '../theme';
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { INLINES, BLOCKS } from '@contentful/rich-text-types'

const BlogPostTemplate = ({ data, location }) => {
  const post = data.contentfulPost;
  const relatedPosts = data.allCategoryPosts.edges;
  const mostRecentPosts = data.allContentfulPost.edges;
  const siteTitle = "Jayla + Artur";
  const { previous, next } = data;
  const jsonPost = JSON.parse(post.body.raw);
  //const image = post.featuredImage.gatsbyImageData
  const image = getImage(post.media);

  // const options = {
  //   renderNode: {
  //     "embedded-asset-block": node => {
  //       const alt = node.data.target.fields.title["en-US"]
  //       const url = node.data.target.fields.file["en-US"].url
  //       return <img alt={alt} src={url} />
  //     },
  //   },
  // }

  const isClient = typeof window !== 'undefined';
  // const options = {
  //   renderNode: {
  //     [INLINES.HYPERLINK]: (node) => {
  //       const caption = node.content[0].value;
  //       const captionArray = caption.split(":");
	// 			if (node.data.uri.indexOf('youtube.com') !== -1) {
  //         if (isClient && captionArray[0] && captionArray[0] === "landscape" ) {
	// 				return (
	// 					<span className="youtube-video">
	// 						<iframe
  //               style={{margin: "auto", minHeight: "200px"}}
	// 							id="ytplayer"
  //               title={post.title}
	// 							src={node.data.uri}
	// 							type="text/html"
  //               width={window.innerWidth > 672 ? 600 : window.innerWidth - 60}
	// 							height={window.innerWidth > 672 ? 337 : (window.innerWidth - 60) / 1.7777}
  //               loop="1"
	// 							allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture ; fullscreen;"
	// 						/>
  //             <span className="youtube-short-caption">{captionArray[1]}</span>
	// 					</span>
	// 				);
  //         } else {
  //           return (
  //             <span className="youtube-video">
  //               <iframe
  //                 style={{margin: "auto"}}
  //                 id="ytplayer"
  //                 title={post.title}
  //                 src={node.data.uri}
  //                 type="text/html"
  //                 width="300"
  //                 height="532"
  //                 loop="1"
  //                 allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture ; fullscreen;"
  //               />
  //               <span className="youtube-short-caption">{node.content[0].value}</span>
  //             </span>
  //           );
  //         }
	// 			} else
	// 				return (
	// 					<a
	// 						href={node.data.uri}
	// 						target={'_blank'}
	// 						rel={'noopener noreferrer'}
	// 					>
	// 						{node.content[0].value}
	// 					</a>
	// 				);
	// 		},
  //     [BLOCKS.EMBEDDED_ASSET]: (node) => {
  //       debugger;
  //       // render the EMBEDDED_ASSET as you need
  //       return (
  //         <img
  //           src={`https://${node.data.target.fields.file.url}`}
  //           height={node.data.target.fields.file.details.image.height}
  //           width={node.data.target.fields.file.details.image.width}
  //           alt={node.data.target.fields.description}
  //         />
  //       );
  //     }, 
  //   }
  // }

  function renderOptions(references) {
   // create an asset map
  const assetMap = new Map();

  // loop through the linked assets and add them to a map
  for (const asset of references) {
    assetMap.set(asset.contentful_id, asset);
  }
  
    return {
      // other options...
  
      renderNode: {
        [INLINES.HYPERLINK]: (node) => {
          const caption = node.content[0].value;
          const captionArray = caption.split(":");
          if (node.data.uri.indexOf('youtube.com') !== -1 && node.data.uri.indexOf('embed') !== -1) {
            if (isClient && captionArray[0] && captionArray[0] === "landscape" ) {
            return (
              <span className="youtube-video">
                <iframe
                  style={{margin: "auto", minHeight: "200px"}}
                  id="ytplayer"
                  title={post.title}
                  src={node.data.uri}
                  type="text/html"
                  width={window.innerWidth > 672 ? 600 : window.innerWidth - 60}
                  height={window.innerWidth > 672 ? 337 : (window.innerWidth - 60) / 1.7777}
                  loop="1"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture ; fullscreen;"
                />
                <span className="youtube-short-caption">{captionArray[1]}</span>
              </span>
            );
            } else {
              return (
                <span className="youtube-video">
                  <iframe
                    style={{margin: "auto"}}
                    id="ytplayer"
                    title={post.title}
                    src={node.data.uri}
                    type="text/html"
                    width="300"
                    height="532"
                    loop="1"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture ; fullscreen;"
                  />
                  <span className="youtube-short-caption">{node.content[0].value}</span>
                </span>
              );
            }
          } else if (node.data.uri.indexOf('youtube.com') !== -1 && node.data.uri.indexOf('list=') !== -1){
            return (
              <div className="youtube-playlist-box">
                <a
                  href={node.data.uri}
                  target={'_blank'}
                  rel={'noopener noreferrer'}
                  >
                <div className="youtube-playlist-icon-list">
                <YouTubeIcon fontSize='large' className="youtube-playlist-icon" />
                <div className="youtube-playlist-link">
                
                 
                    {node.content[0].value}
                  
                </div>
                </div>
                </a>
              </div>
            )
          } 
          else if (node.data.uri.indexOf('youtube.com/@') !== -1){
            return (
              <div className="youtube-channel-box">
                <a
                  href={node.data.uri}
                  target={'_blank'}
                  rel={'noopener noreferrer'}
                  >
                <div className="youtube-channel-icon-list">
                <YouTubeIcon fontSize='large' className="youtube-channel-icon" />
                <div className="youtube-channel-link">
                
                 
                    {node.content[0].value}
                  
                </div>
                </div>
                </a>
              </div>
            )
          } 
          else {
            return (
              <a
                href={node.data.uri}
                target={'_blank'}
                rel={'noopener noreferrer'}
              >
                {node.content[0].value}
              </a>
            );
          }
        },
        [BLOCKS.EMBEDDED_ASSET]: (node) => {
          // find the asset in the assetMap by ID
          const asset = assetMap.get(node.data.target.sys.id);
          
  
          const { gatsbyImageData, title } = asset;

          return (
            <span className="embedded-image">
              <GatsbyImage
                image={getImage(gatsbyImageData)}
                alt={title}
              />
              <span className="embedded-image-caption">{title}</span>
            </span>
          );
        },
      },
    };
  }
  return (
    <ThemeProvider theme={theme} >
      <Layout location={location} title={siteTitle}>
        <Seo
          title={post.title}
          description={post.summary.summary}
        />
        <article
          className="blog-post"
          itemScope
          itemType="http://schema.org/Article"
        >
          <div className="post-list-item-category-date">
                    <div style={{display: "flex"}}>
                      <div className="post-list-item-date">{post.date}</div>
                      <div className="category-date-separator">·</div>
                      <Link to={`../${post.category[0].toLowerCase()}`}><div className="post-list-item-category">{post.category[0]}</div></Link>
                      {/* <div className="post-list-item-category">{post.category[0]}</div>
                      {post.category[1] && 
                        <div className="post-list-item-category">{post.category[1]}</div>
                      } */}
                    </div>
                  </div>
          <header>
            <h1 itemProp="headline">{post.title}</h1>
            <div className="post-summary">
                    <section>
                      <p>
                        {post.summary.summary}
                      </p>
                    </section>
                    </div>
          </header>
          {image && <div className="post-image-container">
                    {/* <Link to={post.node.slug}> */}
                  <GatsbyImage image={image} alt="" className="post-image"/>
              </div>
          }
          {/* <GatsbyImage image={image} alt="" /> */}
          <section
            // dangerouslySetInnerHTML={{ __html: post.body.childMarkdownRemark.html }}
            itemProp="articleBody"
            className="post-body"
          >{documentToReactComponents(jsonPost, renderOptions(post.body.references))}</section>
          <hr />
          <footer>
            <Bio />
          </footer>
        </article>

        <Disqus
          config={{
              /* Replace PAGE_URL with your post's canonical URL variable */
              url: location.href,
              /* Replace PAGE_IDENTIFIER with your page's unique identifier variable */
              identifier: data.contentfulPost.slug,
              /* Replace PAGE_TITLE with the title of the page */
              title: data.contentfulPost.title,
          }}
        />
        
        {/* <nav className="blog-post-nav">
          <ul
            style={{
             


              listStyle: `none`,
              padding: 0,
            }}
          >
            {next &&
              <li className="post-nav-next">Next Post</li>
             }
            <li className="post-nav-next-link" >
              {next && (
                <Link to={`/${next.slug}`} rel="next">
                  {next.title} →
                </Link>
              )}
            </li>
            {previous && next && <hr /> }
            {previous &&
              <li className="post-nav-previous">Previous Post</li>
             }
            <li className="post-nav-previous-link">
              {previous && (
                <Link to={`/${previous.slug}`} rel="prev">
                  ← {previous.title}
                </Link>
              )}
            </li>
          </ul>
        </nav> */}
        {relatedPosts.length > 0 ?
          <div className="post-related-posts">
          <div className="related-posts-title" >Related Posts</div>
            <ol style={{ listStyle: `none` }}>
              {relatedPosts.map(post => {
                return(<PostCard postData={post} key={post.node.slug} />);
              })}
            </ol>
        </div>
          :
          <div className="post-related-posts">
          <div className="related-posts-title" >Recent Posts</div>
            <ol style={{ listStyle: `none` }}>
              {mostRecentPosts.map(post => {
                return(<PostCard postData={post} key={post.node.slug} />);
              })}
            </ol>
        </div>
          }
        {/* {relatedPosts.length > 0 && 
        <div className="post-related-posts">
          <div className="related-posts-title" >Related Posts</div>
            <ol style={{ listStyle: `none` }}>
              {relatedPosts.map(post => {
                return(<PostCard postData={post} key={post.node.slug} />);
              })}
            </ol>
        </div>
      } */}
      </Layout>
    </ThemeProvider>
  );
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query pageQuery(
    $id: String!
    $previousPostId: String
    $nextPostId: String
    $category: String
    )
    {
      contentfulPost(id: {eq: $id}) {
        id
        title
        summary {
          summary
        }
        date(formatString: "MMMM D, YYYY")
        body {
          raw
          references {
            ... on ContentfulAsset {
              __typename
              contentful_id
              id
              title
              file {
                url
              }
            }
            gatsbyImageData(
              width: 640
              placeholder: BLURRED
              )
          }
        }
        media {
          gatsbyImageData(
            width: 640
            placeholder: BLURRED
            )
        }
        category
        slug
      }
      previous: contentfulPost(id: {eq: $previousPostId}) {
        slug
        title
      }
      next: contentfulPost(id: {eq: $nextPostId}) {
        slug
        title
      }
      allCategoryPosts: allContentfulPost(sort: {date: DESC}, filter: {category: {in: [$category]}, id: {ne: $id}}) {
        edges {
          node {
            id
            title
            slug
            date(formatString: "MMM D")
            summary {
              summary
            }
            media {
                gatsbyImageData(
                  width: 640
                  placeholder: BLURRED
                  )
            }
          category
          }
        }
      }
      allContentfulPost(sort: {date: DESC}, filter: {id: {ne: $id}}, limit: 10) {
        edges {
          node {
            id
            title
            slug
            date(formatString: "MMM D")
            summary {
              summary
            }
            media {
                gatsbyImageData(
                  width: 640
                  placeholder: BLURRED
                  )
            }
          category
          }
        }
      }

    }
`

// featuredImage {
//   gatsbyImageData(
//     placeholder: BLURRED
//     formats: [AUTO, WEBP]
//     layout: FULL_WIDTH
//   )
// }

// export const pageQuery = graphql`
//   query BlogPostBySlug(
//     $id: String!
//     $previousPostId: String
//     $nextPostId: String
//   ) {
//     site {
//       siteMetadata {
//         title
//       }
//     }
//     markdownRemark(id: { eq: $id }) {
//       id
//       excerpt(pruneLength: 160)
//       html
//       frontmatter {
//         title
//         date(formatString: "MMMM DD, YYYY")
//         description
//       }
//     }
//     previous: markdownRemark(id: { eq: $previousPostId }) {
//       fields {
//         slug
//       }
//       frontmatter {
//         title
//       }
//     }
//     next: markdownRemark(id: { eq: $nextPostId }) {
//       fields {
//         slug
//       }
//       frontmatter {
//         title
//       }
//     }
//   }
// `